export function dependencyFilters(state = [], action) {
  switch (action.type) {
    case 'dependency_filter':
      const dependencyFilter = action.payload.data.map(item => ({value:item.id, label:item.name}))
      return dependencyFilter;
    default:
      return state
  }
}